module.exports = __webpack_public_path__ + "img/charme_natural_ba_list.21d26dad.jpg";